<template>
  <div class="statistics container">
    <div class="top_info">
      <!-- <div class="title">学情统计</div> -->
      <!-- <div class="class_info">
        <span>班级：{{ classInfo.name }}</span>
        <span>团队数：{{ classInfo.teamCount }}个</span>
        <span>学生数：{{ classInfo.studentCount }}人</span>
      </div> -->
    </div>
    <div class="main">
      <!-- <div class="course_info">
        <p class="info_title">课程概况</p>
        <div class="content">
          <p>{{ $route.query.chapterTitle }}</p>
        </div>
      </div> -->
      <div class="data">
        <!-- <p class="data_title">学情统计</p> -->
        <div class="circle">
          <div
            class="item"
            @click="
              $router.push({
                path: '/courseDetail/statistics/detail',
                query: {
                  ...$route.query,
                  type: 'video',
                },
              })
            "
          >
            <p class="title">视频数据</p>
            <b>{{ statisticsinfo.videoRate }} %</b>
          </div>
          <div
            class="item"
            @click="
              $router.push({
                path: '/courseDetail/statistics/detail',
                query: {
                  ...$route.query,
                  type: 'ppt',
                },
              })
            "
          >
            <p class="title">PPT数据</p>
            <b>{{ statisticsinfo.pptRate }} %</b>
          </div>
          <div
            class="item"
            @click="
              $router.push({
                path: '/courseDetail/statistics/detail',
                query: {
                  ...$route.query,
                  type: 'test',
                },
              })
            "
          >
            <p class="title">考核数据</p>
            <b>{{ statisticsinfo.testRate }} %</b>
          </div>
          <div
            class="item"
            @click="
              $router.push({
                path: '/courseDetail/statistics/detail',
                query: {
                  ...$route.query,
                  type: 'works',
                },
              })
            "
          >
            <p class="title">实战数据</p>
            <b>{{ statisticsinfo.szRate }} %</b>
          </div>
        </div>
        <!-- <div
          class="one"
          @click="
            $router.push({
              path: '/courseDetail/statistics/detail',
              query: {
                ...$route.query,
                type: 'video',
              },
            })
          "
        >
          <p>视频统计</p>
          <el-progress
            :stroke-width="30"
            :percentage="statisticsinfo.videoRate"
            :text-inside="true"
          ></el-progress>
        </div>
        <div
          class="one"
          @click="
            $router.push({
              path: '/courseDetail/statistics/detail',
              query: {
                ...$route.query,
                type: 'ppt',
              },
            })
          "
        >
          <p>PPT统计</p>
          <el-progress
            :stroke-width="30"
            :percentage="statisticsinfo.pptRate"
            :text-inside="true"
          ></el-progress>
        </div>
        <div
          class="one"
          @click="
            $router.push({
              path: '/courseDetail/statistics/detail',
              query: {
                ...$route.query,
                type: 'test',
              },
            })
          "
        >
          <p>测评统计</p>
          <el-progress
            :stroke-width="30"
            :percentage="statisticsinfo.testRate"
            :text-inside="true"
          ></el-progress>
        </div>
        <div
          class="one"
          @click="
            $router.push({
              path: '/courseDetail/statistics/detail',
              query: {
                ...$route.query,
                type: 'works',
              },
            })
          "
        >
          <p>实战统计</p>
          <el-progress
            :stroke-width="30"
            :percentage="statisticsinfo.szRate"
            :text-inside="true"
          ></el-progress>
        </div> -->
        <!-- <div class="one">
          <p>随堂练习</p>
          <el-progress
            type="circle"
            :stroke-width="20"
            :percentage="(info.lianxi / info.studentNum).toFixed(2) * 100"
            :format="(percentage) => format(percentage, info.lianxi)"
          ></el-progress>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { chapterStatistics } from "@/api/chapter";
import { classInfo } from "@/api/class";
export default {
  props: {
    info: Object,
  },
  data() {
    return {
      classInfo: {},
      statisticsinfo: {
        pptRate: 0,
        szRate: 0,
        testRate: 0,
        videoRate: 0,
      },
    };
  },
  activated() {
    this.getClassInfo();
    this.getStatistics();
  },
  methods: {
    // 班级信息
    getClassInfo() {
      classInfo(this.$route.query.id).then((res) => {
        if (res.code == 0) {
          // console.log(res);
          this.classInfo = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
    getStatistics() {
      this.$loading.show();
      chapterStatistics(this.$route.query.classChapterId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.statisticsinfo = res.data;
        } else {
          console.log(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.statistics {
  padding-top: 20px;
  height: 100%;
  .top_info {
    .title {
      padding: 5px;
      color: #fff;
      font-size: 18px;
      background-color: #505050;
    }
    .class_info {
      padding: 5px;
      color: #505050;
      font-size: 16px;
      border: solid 1px #505050;
      span {
        margin-right: 20px;
      }
    }
  }
  .main {
    height: calc(100% - 67px - 20px);
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }

    .course_info {
      margin-top: 30px;
      padding: 20px;
      text-align: left;
      border: solid 1px #505050;
      border-radius: 8px;
      .info_title {
        color: #505050;
        font-size: 16px;
      }
      .content {
        margin-top: 10px;
        padding: 10px;
        background-color: rgb(226, 236, 248);
        p {
          color: #333;
          line-height: 1.5;
        }
      }
    }

    .data {
      margin-top: 50px;
      padding: 20px;
      text-align: center;
      // border: solid 1px #505050;
      border-radius: 8px;
      .circle {
        display: inline-block;
        width: 500px;
        height: 500px;
        background: #f56c6c;
        border-radius: 50%;
        overflow: hidden;
        .item {
          display: inline-block;
          width: 250px;
          height: 250px;
          color: #fff;
          border: solid 1px #fff;
          vertical-align: top;
          transition: all 0.3s ease;
          cursor: pointer;
          &:hover {
            background: #409eff;
          }
          .title {
            margin-top: 80px;
            margin-bottom: 20px;
            font-size: 18px;
            font-weight: bold;
          }
          b {
            font-size: 28px;
          }
        }
      }
      .data_title {
        margin-bottom: 30px;
        color: #505050;
        font-weight: bold;
        font-size: 16px;
      }
      .one {
        display: inline-block;
        margin: 0 35px;
        width: 200px;
        text-align: center;
        cursor: pointer;
        p {
          margin-bottom: 50px;
          font-size: 16px;
        }
      }
    }
  }
}
</style>